import axios from 'axios'
import { SET_TIMELINE_LOADING, GET_TIMELINE_DATA, CLEAR_TIMELINE_DATA } from './types'
import { notificationDanger } from '../../../../utils/customToastify'

const setTimelineLoading = () => ({
  type: SET_TIMELINE_LOADING,
})

export const clearTimelineData = () => (dispatch) => {
  dispatch({ type: CLEAR_TIMELINE_DATA })
}

export const getTimelineData = (filter, pagination, isRefresh) => async (dispatch) => {
  try {
    dispatch(setTimelineLoading())
    const response = await axios.get('/contact-activities-timeline/all', {
      params: { filter, pagination, isRefresh },
    })
    dispatch({
      type: GET_TIMELINE_DATA,
      payload: response.data,
    })
  } catch (err) {
    dispatch(setTimelineLoading())
    notificationDanger('Server Error! Something went wrong')
  }
}
